// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/morgans/v1/qualification.proto (package mono.morgans.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.morgans.v1.QualificationTemplateVersion
 */ export class QualificationTemplateVersion extends Message {
    static fromBinary(bytes, options) {
        return new QualificationTemplateVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QualificationTemplateVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QualificationTemplateVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QualificationTemplateVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: string template_name = 3;
   */ _define_property(this, "templateName", ""), /**
   * @generated from field: int32 version = 4;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string criteria_json = 5;
   */ _define_property(this, "criteriaJson", ""), /**
   * @generated from field: string created_by = 6;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QualificationTemplateVersion, "runtime", proto3);
_define_property(QualificationTemplateVersion, "typeName", "mono.morgans.v1.QualificationTemplateVersion");
_define_property(QualificationTemplateVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "template_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "criteria_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.morgans.v1.QualificationEvaluation
 */ export class QualificationEvaluation extends Message {
    static fromBinary(bytes, options) {
        return new QualificationEvaluation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QualificationEvaluation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QualificationEvaluation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QualificationEvaluation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string template_version_id = 3;
   */ _define_property(this, "templateVersionId", ""), /**
   * @generated from field: string template_name = 4;
   */ _define_property(this, "templateName", ""), /**
   * @generated from field: int32 template_version = 5;
   */ _define_property(this, "templateVersion", 0), /**
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string answers_json = 7;
   */ _define_property(this, "answersJson", ""), /**
   * @generated from field: string created_by = 8;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * server-owned source basis and review state
   *
   * @generated from field: string suggestions_json = 11;
   */ _define_property(this, "suggestionsJson", ""), /**
   * server-owned current answer lineage
   *
   * @generated from field: string answer_basis_json = 12;
   */ _define_property(this, "answerBasisJson", ""), /**
   * basis changed after the latest disposition
   *
   * @generated from field: bool reconsideration_needed = 13;
   */ _define_property(this, "reconsiderationNeeded", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QualificationEvaluation, "runtime", proto3);
_define_property(QualificationEvaluation, "typeName", "mono.morgans.v1.QualificationEvaluation");
_define_property(QualificationEvaluation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "template_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "template_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "answers_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "suggestions_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "answer_basis_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "reconsideration_needed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.QualificationEvaluationEvent
 */ export class QualificationEvaluationEvent extends Message {
    static fromBinary(bytes, options) {
        return new QualificationEvaluationEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QualificationEvaluationEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QualificationEvaluationEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QualificationEvaluationEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string evaluation_id = 2;
   */ _define_property(this, "evaluationId", ""), /**
   * @generated from field: string event_type = 3;
   */ _define_property(this, "eventType", ""), /**
   * @generated from field: string template_version_id = 4;
   */ _define_property(this, "templateVersionId", ""), /**
   * @generated from field: int32 template_version = 5;
   */ _define_property(this, "templateVersion", 0), /**
   * @generated from field: string answers_snapshot_json = 6;
   */ _define_property(this, "answersSnapshotJson", ""), /**
   * @generated from field: string disposition = 7;
   */ _define_property(this, "disposition", ""), /**
   * @generated from field: string note = 8;
   */ _define_property(this, "note", ""), /**
   * @generated from field: string actor = 9;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string answer_basis_snapshot_json = 11;
   */ _define_property(this, "answerBasisSnapshotJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QualificationEvaluationEvent, "runtime", proto3);
_define_property(QualificationEvaluationEvent, "typeName", "mono.morgans.v1.QualificationEvaluationEvent");
_define_property(QualificationEvaluationEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "evaluation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "event_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "template_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "answers_snapshot_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "disposition",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "answer_basis_snapshot_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CreateQualificationTemplateVersionRequest
 */ export class CreateQualificationTemplateVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateQualificationTemplateVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateQualificationTemplateVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateQualificationTemplateVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateQualificationTemplateVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string template_name = 1;
   */ _define_property(this, "templateName", ""), /**
   * @generated from field: string criteria_json = 2;
   */ _define_property(this, "criteriaJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateQualificationTemplateVersionRequest, "runtime", proto3);
_define_property(CreateQualificationTemplateVersionRequest, "typeName", "mono.morgans.v1.CreateQualificationTemplateVersionRequest");
_define_property(CreateQualificationTemplateVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "criteria_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.CreateQualificationTemplateVersionResponse
 */ export class CreateQualificationTemplateVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateQualificationTemplateVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateQualificationTemplateVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateQualificationTemplateVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateQualificationTemplateVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.QualificationTemplateVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateQualificationTemplateVersionResponse, "runtime", proto3);
_define_property(CreateQualificationTemplateVersionResponse, "typeName", "mono.morgans.v1.CreateQualificationTemplateVersionResponse");
_define_property(CreateQualificationTemplateVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: QualificationTemplateVersion
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListQualificationTemplateVersionsRequest
 */ export class ListQualificationTemplateVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListQualificationTemplateVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListQualificationTemplateVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListQualificationTemplateVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListQualificationTemplateVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string template_name = 1;
   */ _define_property(this, "templateName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListQualificationTemplateVersionsRequest, "runtime", proto3);
_define_property(ListQualificationTemplateVersionsRequest, "typeName", "mono.morgans.v1.ListQualificationTemplateVersionsRequest");
_define_property(ListQualificationTemplateVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListQualificationTemplateVersionsResponse
 */ export class ListQualificationTemplateVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListQualificationTemplateVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListQualificationTemplateVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListQualificationTemplateVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListQualificationTemplateVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.QualificationTemplateVersion versions = 1;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListQualificationTemplateVersionsResponse, "runtime", proto3);
_define_property(ListQualificationTemplateVersionsResponse, "typeName", "mono.morgans.v1.ListQualificationTemplateVersionsResponse");
_define_property(ListQualificationTemplateVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: QualificationTemplateVersion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.morgans.v1.StartQualificationEvaluationRequest
 */ export class StartQualificationEvaluationRequest extends Message {
    static fromBinary(bytes, options) {
        return new StartQualificationEvaluationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartQualificationEvaluationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartQualificationEvaluationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartQualificationEvaluationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string template_version_id = 2;
   */ _define_property(this, "templateVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartQualificationEvaluationRequest, "runtime", proto3);
_define_property(StartQualificationEvaluationRequest, "typeName", "mono.morgans.v1.StartQualificationEvaluationRequest");
_define_property(StartQualificationEvaluationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.StartQualificationEvaluationResponse
 */ export class StartQualificationEvaluationResponse extends Message {
    static fromBinary(bytes, options) {
        return new StartQualificationEvaluationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartQualificationEvaluationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartQualificationEvaluationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartQualificationEvaluationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.QualificationEvaluation evaluation = 1;
   */ _define_property(this, "evaluation", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StartQualificationEvaluationResponse, "runtime", proto3);
_define_property(StartQualificationEvaluationResponse, "typeName", "mono.morgans.v1.StartQualificationEvaluationResponse");
_define_property(StartQualificationEvaluationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation",
            kind: "message",
            T: QualificationEvaluation
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetQualificationEvaluationRequest
 */ export class GetQualificationEvaluationRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetQualificationEvaluationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetQualificationEvaluationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetQualificationEvaluationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetQualificationEvaluationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: bool refresh_suggestions = 2;
   */ _define_property(this, "refreshSuggestions", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetQualificationEvaluationRequest, "runtime", proto3);
_define_property(GetQualificationEvaluationRequest, "typeName", "mono.morgans.v1.GetQualificationEvaluationRequest");
_define_property(GetQualificationEvaluationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "refresh_suggestions",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.GetQualificationEvaluationResponse
 */ export class GetQualificationEvaluationResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetQualificationEvaluationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetQualificationEvaluationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetQualificationEvaluationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetQualificationEvaluationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.QualificationEvaluation evaluation = 1;
   */ _define_property(this, "evaluation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetQualificationEvaluationResponse, "runtime", proto3);
_define_property(GetQualificationEvaluationResponse, "typeName", "mono.morgans.v1.GetQualificationEvaluationResponse");
_define_property(GetQualificationEvaluationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation",
            kind: "message",
            T: QualificationEvaluation
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UpdateQualificationAnswersRequest
 */ export class UpdateQualificationAnswersRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateQualificationAnswersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateQualificationAnswersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateQualificationAnswersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateQualificationAnswersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evaluation_id = 1;
   */ _define_property(this, "evaluationId", ""), /**
   * @generated from field: string answers_json = 2;
   */ _define_property(this, "answersJson", ""), /**
   * @generated from field: string suggestion_id = 3;
   */ _define_property(this, "suggestionId", ""), /**
   * accepted | edited | rejected
   *
   * @generated from field: string review_action = 4;
   */ _define_property(this, "reviewAction", ""), /**
   * @generated from field: string edited_value_json = 5;
   */ _define_property(this, "editedValueJson", ""), /**
   * datagateway: trusted adapter only; browser value ignored
   *
   * @generated from field: string actor = 6;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateQualificationAnswersRequest, "runtime", proto3);
_define_property(UpdateQualificationAnswersRequest, "typeName", "mono.morgans.v1.UpdateQualificationAnswersRequest");
_define_property(UpdateQualificationAnswersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "answers_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "suggestion_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "review_action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "edited_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.UpdateQualificationAnswersResponse
 */ export class UpdateQualificationAnswersResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateQualificationAnswersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateQualificationAnswersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateQualificationAnswersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateQualificationAnswersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.QualificationEvaluation evaluation = 1;
   */ _define_property(this, "evaluation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateQualificationAnswersResponse, "runtime", proto3);
_define_property(UpdateQualificationAnswersResponse, "typeName", "mono.morgans.v1.UpdateQualificationAnswersResponse");
_define_property(UpdateQualificationAnswersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation",
            kind: "message",
            T: QualificationEvaluation
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DeferQualificationEvaluationRequest
 */ export class DeferQualificationEvaluationRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeferQualificationEvaluationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeferQualificationEvaluationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeferQualificationEvaluationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeferQualificationEvaluationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evaluation_id = 1;
   */ _define_property(this, "evaluationId", ""), /**
   * @generated from field: string note = 2;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeferQualificationEvaluationRequest, "runtime", proto3);
_define_property(DeferQualificationEvaluationRequest, "typeName", "mono.morgans.v1.DeferQualificationEvaluationRequest");
_define_property(DeferQualificationEvaluationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DeferQualificationEvaluationResponse
 */ export class DeferQualificationEvaluationResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeferQualificationEvaluationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeferQualificationEvaluationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeferQualificationEvaluationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeferQualificationEvaluationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.QualificationEvaluation evaluation = 1;
   */ _define_property(this, "evaluation", void 0), /**
   * @generated from field: mono.morgans.v1.QualificationEvaluationEvent event = 2;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeferQualificationEvaluationResponse, "runtime", proto3);
_define_property(DeferQualificationEvaluationResponse, "typeName", "mono.morgans.v1.DeferQualificationEvaluationResponse");
_define_property(DeferQualificationEvaluationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation",
            kind: "message",
            T: QualificationEvaluation
        },
        {
            no: 2,
            name: "event",
            kind: "message",
            T: QualificationEvaluationEvent
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ResumeQualificationEvaluationRequest
 */ export class ResumeQualificationEvaluationRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResumeQualificationEvaluationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResumeQualificationEvaluationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResumeQualificationEvaluationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResumeQualificationEvaluationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evaluation_id = 1;
   */ _define_property(this, "evaluationId", ""), /**
   * @generated from field: string note = 2;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResumeQualificationEvaluationRequest, "runtime", proto3);
_define_property(ResumeQualificationEvaluationRequest, "typeName", "mono.morgans.v1.ResumeQualificationEvaluationRequest");
_define_property(ResumeQualificationEvaluationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ResumeQualificationEvaluationResponse
 */ export class ResumeQualificationEvaluationResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResumeQualificationEvaluationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResumeQualificationEvaluationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResumeQualificationEvaluationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResumeQualificationEvaluationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.QualificationEvaluation evaluation = 1;
   */ _define_property(this, "evaluation", void 0), /**
   * @generated from field: mono.morgans.v1.QualificationEvaluationEvent event = 2;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResumeQualificationEvaluationResponse, "runtime", proto3);
_define_property(ResumeQualificationEvaluationResponse, "typeName", "mono.morgans.v1.ResumeQualificationEvaluationResponse");
_define_property(ResumeQualificationEvaluationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation",
            kind: "message",
            T: QualificationEvaluation
        },
        {
            no: 2,
            name: "event",
            kind: "message",
            T: QualificationEvaluationEvent
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DispositionQualificationEvaluationRequest
 */ export class DispositionQualificationEvaluationRequest extends Message {
    static fromBinary(bytes, options) {
        return new DispositionQualificationEvaluationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DispositionQualificationEvaluationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DispositionQualificationEvaluationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DispositionQualificationEvaluationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evaluation_id = 1;
   */ _define_property(this, "evaluationId", ""), /**
   * @generated from field: string disposition = 2;
   */ _define_property(this, "disposition", ""), /**
   * @generated from field: string note = 3;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DispositionQualificationEvaluationRequest, "runtime", proto3);
_define_property(DispositionQualificationEvaluationRequest, "typeName", "mono.morgans.v1.DispositionQualificationEvaluationRequest");
_define_property(DispositionQualificationEvaluationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "disposition",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.DispositionQualificationEvaluationResponse
 */ export class DispositionQualificationEvaluationResponse extends Message {
    static fromBinary(bytes, options) {
        return new DispositionQualificationEvaluationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DispositionQualificationEvaluationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DispositionQualificationEvaluationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DispositionQualificationEvaluationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.morgans.v1.QualificationEvaluation evaluation = 1;
   */ _define_property(this, "evaluation", void 0), /**
   * @generated from field: mono.morgans.v1.QualificationEvaluationEvent event = 2;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DispositionQualificationEvaluationResponse, "runtime", proto3);
_define_property(DispositionQualificationEvaluationResponse, "typeName", "mono.morgans.v1.DispositionQualificationEvaluationResponse");
_define_property(DispositionQualificationEvaluationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation",
            kind: "message",
            T: QualificationEvaluation
        },
        {
            no: 2,
            name: "event",
            kind: "message",
            T: QualificationEvaluationEvent
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListQualificationEvaluationEventsRequest
 */ export class ListQualificationEvaluationEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListQualificationEvaluationEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListQualificationEvaluationEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListQualificationEvaluationEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListQualificationEvaluationEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evaluation_id = 1;
   */ _define_property(this, "evaluationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListQualificationEvaluationEventsRequest, "runtime", proto3);
_define_property(ListQualificationEvaluationEventsRequest, "typeName", "mono.morgans.v1.ListQualificationEvaluationEventsRequest");
_define_property(ListQualificationEvaluationEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evaluation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.morgans.v1.ListQualificationEvaluationEventsResponse
 */ export class ListQualificationEvaluationEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListQualificationEvaluationEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListQualificationEvaluationEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListQualificationEvaluationEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListQualificationEvaluationEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.morgans.v1.QualificationEvaluationEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListQualificationEvaluationEventsResponse, "runtime", proto3);
_define_property(ListQualificationEvaluationEventsResponse, "typeName", "mono.morgans.v1.ListQualificationEvaluationEventsResponse");
_define_property(ListQualificationEvaluationEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: QualificationEvaluationEvent,
            repeated: true
        }
    ]));
